module.exports = __webpack_public_path__ + "static/userscience-b3d40537855632476ff623b1ebd2a5a2.png";